(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bullit-jeans-carousel"] && !Shopify.designMode) return;
  try {
    

    function pad(int) {
        if (int >= 10) {
            return int.toString();
        }
        else {
            return "0" + int.toString();
        }
    }

    function refreshPagination(carousel) {
        const index = Math.ceil(carousel.scrollLeft / carousel.offsetWidth) + 1;
        const container = carousel.closest(".jeans-carousel-container");

        const totalEl = container.querySelector(".jeans-carousel-pagination-fractions-total");

        const currentIndexEl = container.querySelector(".jeans-carousel-pagination-fractions span");
        currentIndexEl.innerHTML = pad(index);

        const total = Math.ceil(carousel.scrollWidth / carousel.offsetWidth);

        totalEl.innerHTML = pad(total);

        const pagination = container.querySelector(".jeans-carousel-pagination");

        pagination.style.display = total == 1 ? "none" : null;

    }

    function paginatePrevious(carousel) {
        carousel.scrollTo({
            top: 0,
            left: carousel.scrollLeft - carousel.offsetWidth,
            behavior: "smooth"
        });
        refreshPagination(carousel);
    }

    function paginateNext(carousel) {
        carousel.scrollTo({
            top: 0,
            left: carousel.scrollLeft + carousel.offsetWidth,
            behavior: "smooth"
        });
        refreshPagination(carousel);
    }

    const jeansCarousels = document.querySelectorAll(".jeans-carousel");

    for (const carousel of jeansCarousels) {
        refreshPagination(carousel);
        carousel.addEventListener("scroll", (ev) => {
            refreshPagination(carousel);
        });
    }

    window.addEventListener("resize", (ev) => {
        requestAnimationFrame(() => {
            for (const carousel of jeansCarousels) {
                refreshPagination(carousel);
            }
        });
    })

    window.addEventListener("click", (ev) => {
        const button = ev.target.closest(".jeans-carousel-pagination__button");

        if (button) {
            const carousel = button.closest(".jeans-carousel-container").querySelector(".jeans-carousel");

            if (button.classList.contains("jeans-carousel-pagination__button--next")) {
                paginateNext(carousel);
            } else {
                paginatePrevious(carousel);
            }
        }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bullit-shipping-dialog"] && !Shopify.designMode) return;
  try {
    
    const addToCartButton = document.querySelector(".button[id^=BuyButtons-ProductSubmitButton-]"),
          shippingDialog = document.querySelector(".bullit-shipping-dialog"),
          shippingDialogCheckbox = document.querySelector(".bullit-shipping-dialog__checkbox"),
          shippingSubmit = document.querySelector(".bullit-shipping-dialog__submit");

    addToCartButton.addEventListener("click", (ev) => {
        if (!shippingDialog)
            return;

        if (!sessionStorage.getItem("shipping-notice-dismissed")) {
            shippingDialog.showModal();
        }
    });

    if (shippingDialogCheckbox) {
        shippingDialogCheckbox.addEventListener("change", (ev) => {
            shippingSubmit.disabled = !shippingDialogCheckbox.checked;
        });
    }

    if (shippingSubmit) {
        shippingSubmit.addEventListener("click", (ev) => {
            sessionStorage.setItem("shipping-notice-dismissed", true);
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-guide"] && !Shopify.designMode) return;
  try {
    
  const imperialSwitch = document.querySelector(".imperial-switch-checkbox");

  function initSizingGuide() {
    if (!imperialSwitch) {
      return;
    }

    const sizingGuide = document.querySelector(".sizing-guide");

    if (!sizingGuide)
      return;

    if (sizingGuide.getAttribute("data-unit-display") == "imperial") {
      imperialSwitch.checked = true;
    }

    imperialSwitch.addEventListener("change", (ev) => {
      sizingGuide.setAttribute("data-unit-display", imperialSwitch.checked ? 'imperial' : 'metric' );
    });
  }

  initSizingGuide();

  } catch(e) { console.error(e); }
})();
})();
